// @flow
import * as React from 'react';

import { CookieContainer, InfoIcon } from './styles';
import { injectIntl } from 'react-intl';

import CookieBanner from 'react-cookie-banner';
import messages from './intl';

type Props = {
    isLoading: boolean,
    intl: $npm$ReactIntl$IntlShape
};

const CookiePolicyAlert = ({ isLoading, intl: { formatMessage } }: Props) => (
    <CookieContainer>
        {!isLoading && (
            <CookieBanner
                buttonMessage={<span data-qa="cookie-policy-close">{formatMessage(messages.cookiePolicyConfirm)}</span>}
                cookie="cookie-accepted"
                data-qa="cookie-policy"
                dismissOnScroll={false}
                link={{
                    msg: <InfoIcon />,
                    url: formatMessage(messages.cookiePolicyURL),
                    target: '_blank'
                }}
                message={formatMessage(messages.cookiePolicyMessage)}
                onAccept={() => {}}
                styles={{
                    banner: {
                        backgroundColor: '#E5F5F7',
                        boxShadow: '1px 0px 5px #3D8081',
                        height: '100%',
                        padding: '1rem',
                        overflow: 'auto'
                    },
                    message: {
                        color: '#3E4F56',
                        fontSize: '1rem',
                        lineHeight: '1rem',
                        display: 'inline-block',
                        float: 'left',
                        textAlign: 'left'
                    },
                    link: {
                        color: '#3D8081',
                        fontSize: '1rem',
                        marginLeft: '0'
                    },
                    button: {
                        position: 'relative',
                        right: '0',
                        top: '0',
                        display: 'inline-block',
                        background: 'transparent',
                        color: '#3D8081',
                        fontSize: '1rem',
                        opacity: '1',
                        height: '1rem',
                        lineHeight: '1rem',
                        marginTop: '0',
                        float: 'right'
                    }
                }}
            />
        )}
    </CookieContainer>
);

export default injectIntl(CookiePolicyAlert);



// WEBPACK FOOTER //
// ./src/components/widgets/cookie-policy/component.js